/**
 * @generated SignedSource<<eae21b43662019639b8ce339e41a3761>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row405BadPattern$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Row73BadPattern">;
  readonly " $fragmentType": "Row405BadPattern";
};
export type Row405BadPattern$key = {
  readonly " $data"?: Row405BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row405BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    }
  ],
  "kind": "Fragment",
  "name": "Row405BadPattern",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Row73BadPattern"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "bd9b93b2c7727e6550cce325e48a30c8";

export default node;
